import React, { useMemo } from "react";
import { shape, string, number } from "prop-types";

const propTypes = {
  query: string,
  request: shape({
    page: number,
    perPage: number,
  }),
  resultsInfoLabel: string,
  totalResults: number.isRequired,
};

const ResultsInfo = (props) => {
  const { query, request, resultsInfoLabel, totalResults } = props;

  const currentResultsRange = useMemo(() => {
    //ensure base 10 number
    const currentPageNumber = parseInt(request.page || 1, 10);
    const resultsPerPageNumber = parseInt(request.perPage || 10, 10);

    // Upper bound of visible results
    let ceiling = currentPageNumber * resultsPerPageNumber;

    // Lower bound of visible results
    let floor = ceiling - resultsPerPageNumber + 1;

    // make sure the ceiling does not exceed total results
    if (ceiling > totalResults) {
      ceiling = totalResults;
    }

    // if results are only one page, eschew the range entirely
    if (totalResults <= resultsPerPageNumber) {
      return ` ${totalResults}`;
    }

    // otherwise, return the full range
    return ` ${floor} - ${ceiling}`;
  }, [request.page, request.perPage, totalResults]);

  return (
    <div className="results-info" aria-live="polite">
      {resultsInfoLabel && (
        <span className="results-info__label">{resultsInfoLabel}</span>
      )}
      {request && (
        <span className="results-info__range">{currentResultsRange}</span>
      )}
      {totalResults > 0 && (
        <span>
          of{" "}
          <span className="results-info__total-results">{`${totalResults}`}</span>
        </span>
      )}
      {query && (
        <span>
          for <span className="results-info__query">{`“${query}”`}</span>
        </span>
      )}
    </div>
  );
};

ResultsInfo.propTypes = propTypes;
export default ResultsInfo;
